import { ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material'
import React, { forwardRef, ReactElement, useMemo } from 'react'
import { NavLink, NavLinkProps } from 'react-router-dom'

interface ListItemLinkProps {
  primary: string
  to: string
  icon?: React.ReactElement
  className?: string
  end?: boolean
  endIcon?: React.ReactElement
  selectable?: boolean
}

const ListItemLink = (props: ListItemLinkProps): ReactElement => {
  const { icon, primary, to, className, endIcon, selectable = true, ...rest } = props
  const renderLink = useMemo(
    () =>
      forwardRef<any, Omit<NavLinkProps, 'to'>>(({ className: defaultStyling, ...itemRest }, ref) => (
        <NavLink
          to={to}
          ref={ref}
          {...itemRest}
          className={({ isActive }) => `${defaultStyling} ${isActive && selectable ? 'Mui-selected' : ''}`}
        />
      )),
    [to],
  )

  return (
    <ListItemButton
      className={className}
      component={renderLink}
      {...rest}
      sx={({ palette }) => ({ paddingLeft: 3, height: '40px', '&.Mui-selected': { color: palette.primary.main } })}
    >
      {icon ? <ListItemIcon sx={{ minWidth: '40px' }}>{icon}</ListItemIcon> : null}
      <Typography variant="subtitle2" sx={{ lineHeight: '100%' }}>
        <ListItemText disableTypography primary={primary} />
      </Typography>

      {endIcon ? <ListItemIcon sx={{ color: 'inherit', paddingLeft: 1 }}>{endIcon}</ListItemIcon> : null}
    </ListItemButton>
  )
}

ListItemLink.displayName = 'ListItemLink'

export { ListItemLink }
